import { useCallback } from 'react';

import { DATE_PLACEHOLDER, TIME_PLACEHOLDER } from './constants';
import type { DateRange } from './types';

const dateFormatter = new Intl.DateTimeFormat('en-US', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
});

const timeFormatter = new Intl.DateTimeFormat('en-US', {
    hour: 'numeric',
    hour12: true,
    minute: 'numeric',
    second: 'numeric'
});

const { format: dateFormat } = dateFormatter;
const { format: timeFormat } = timeFormatter;

const useDateFormat = () => {
    const formatDate = useCallback((date: Date | string) => {
        const dateValue = typeof date === 'string' ? new Date(date) : date;

        return date ? dateFormat(dateValue) : DATE_PLACEHOLDER;
    }, []);

    const formatDateRange = useCallback((range: DateRange) => {
        const { from, to } = range;

        const rangeValues = {
            from: from ? dateFormat(new Date(from)) : from,
            to: to ? dateFormat(new Date(to)) : to
        };

        return rangeValues;
    }, []);

    const formatTime = useCallback(
        (dateTime: string | null) => (dateTime ? timeFormat(new Date(dateTime)) : TIME_PLACEHOLDER),
        []
    );

    return { formatDate, formatDateRange, formatTime };
};

export default useDateFormat;
